import { Injectable } from '@angular/core';

import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})

export class EncrDecrService {
  passphraseLocal : any;
  constructor() { }

  // The set method is use for encrypt the value.
  set(obj) {
    const passphrase = 'BAgtAGHLCb';
    const salt = CryptoJS.lib.WordArray.random(128 / 8);
    const iv = CryptoJS.lib.WordArray.random(128 / 8);
    const key = CryptoJS.PBKDF2(
      passphrase,
      salt,
      { keySize: 128 / 32, iterations: 100 });
    const plaintext = JSON.stringify(obj);
    const encrypted = CryptoJS.AES.encrypt(plaintext, key, { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    let passwordpassed = salt + iv;
    passwordpassed = passwordpassed + encrypted;
    return passwordpassed.toString();
  }

  setNew(obj, passphrase) {
    // const passphrase = 'BAgtAGHLCb';
    const salt = CryptoJS.lib.WordArray.random(128 / 8);
    const result = salt.toString();
    const iv = CryptoJS.lib.WordArray.random(128 / 8);
    const key = CryptoJS.PBKDF2(
      passphrase,
      salt,
      { keySize: 128 / 32, iterations: 100 });
    const plaintext = JSON.stringify(obj);
    const encrypted = CryptoJS.AES.encrypt(plaintext, key, { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    let passwordpassed = result + iv;
    passwordpassed = passwordpassed + encrypted;
    return passwordpassed.toString();
  }

  // The get method is use for decrypt the value.
  get(encryptedText) {
    const passphrase = 'BAgtAGHLCb';
    encryptedText.toString();
    var salt = CryptoJS.enc.Hex.parse(encryptedText.substr(0, 32));
    var iv = CryptoJS.enc.Hex.parse(encryptedText.substr(32, 32))
    var encrypted = encryptedText.substring(64);

    var key = CryptoJS.PBKDF2(passphrase, salt, {
      keySize: 128 / 32,
      iterations: 100
    });

    var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC

    })
    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  }

  getNew(encryptedText, passphrase) {
    // const passphrase = 'BAgtAGHLCb';
    var salt = CryptoJS.enc.Hex.parse(encryptedText.substr(0, 32));
    var iv = CryptoJS.enc.Hex.parse(encryptedText.substr(32, 32))
    var encrypted = encryptedText.substring(64);

    var key = CryptoJS.PBKDF2(passphrase, salt, {
      keySize: 128 / 32,
      iterations: 100
    });

    var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC

    })
    console.log("decrypted response",decrypted.toString(CryptoJS.enc.Utf8));
    var testDec = decrypted.toString(CryptoJS.enc.Utf8);
    // console.warn(testDec);
    return JSON.parse(testDec);
  }

  decryptTeamsite(encryptedText){
    const passphrase = 'BAgtAGHLCb';
    var salt1 = CryptoJS.enc.Hex.parse(encryptedText.substr(0, 16));
    var iv1 = CryptoJS.enc.Hex.parse(encryptedText.substr(16, 16))
    var encrypted1 = encryptedText.substring(32);

    var key1 = CryptoJS.PBKDF2(passphrase, salt1, {
      keySize: 128 / 32,
      iterations: 100
    });

    var decrypted = CryptoJS.AES.decrypt(encrypted1, key1, {
      iv: iv1,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC

    })
    return decrypted.toString(CryptoJS.enc.Utf8);
    // return decrypted.toString(CryptoJS.enc.Utf8);

  }

}
